/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { z } from 'zod';
import { baseCollectionBodySchema } from '../collection-body-schema';

export const updateCollectionBodySchema = baseCollectionBodySchema.partial();

export type IUpdateCollectionBody = z.infer<typeof updateCollectionBodySchema>;

export interface IUpdateCollectionRequest {
  id: number;
  body: IUpdateCollectionBody;
}
